<template>
  <section>
    <b-card title="">
  <b-row xl="12" sm="12">
        <b-col cols="12" md="3">
          <b-form-select v-model="type_report" :options="options" class="mb-3"  
            />
        </b-col>
        <b-col cols="12" md="3">
          <b-input-group>
            <flat-pickr v-model="date_start" class="form-control" :config="{ enableTime: false, time_24hr: false }"
              placeholder="DD-MM-YYYY" @input="changeDate()" />
            <b-input-group-append is-text>
              <feather-icon icon="CalendarIcon" class="cursor-pointer" />
              <b>&nbsp;Start</b>
            </b-input-group-append>
          </b-input-group>
        </b-col>
        <b-col cols="12" md="3">
          <b-input-group>
            <flat-pickr v-model="date_finish" class="form-control" :config="{ enableTime: false, time_24hr: false }"
              placeholder="DD-MM-YYYY" @input="changeDate()" />
            <b-input-group-append is-text>
              <feather-icon icon="ClockIcon" class="cursor-pointer" />
              <b>&nbsp;Finish</b>
            </b-input-group-append>
          </b-input-group>
        </b-col>
        <b-col cols="12" md="3" class="mb-md-0 mb-2">
          <b-button v-ripple.400="'rgba(113, 102, 240, 0.15)'" class="sidebar-center" variant="outline-primary"
            @click="filterData()">
            <feather-icon icon="SearchIcon" /> Filter
          </b-button>
        </b-col>
      </b-row>
    </b-card>

    <div>
      <b-card class="text-center">
        <b-table :items="items" :fields="fields" :current-page="currentPage" :per-page="perPage" :filter="filter"
          :sort-by.sync="sortBy" :sort-desc.sync="sortDesc"
          :sort-direction="sortDirection" stacked="md" show-empty small  />

        <!-- Your existing template code -->

        <b-row>
          <b-col cols="12" md="6">
            <b-form-group label="Per page" label-for="per-page-select" label-cols-sm="6" label-cols-md="4"
              label-cols-lg="3" label-align-sm="right" label-size="sm" class="mb-0">
              <b-form-select id="per-page-select" v-model="perPage" :options="pageOptions" size="sm" />
            </b-form-group>
          </b-col>
          <b-col cols="12" md="6">
            <b-pagination v-model="currentPage" :total-rows="totalRows" :per-page="perPage" align="fill" size="sm"
              class="my-0" />
          </b-col>
        </b-row>
      </b-card>
    </div>

  </section>
</template>
<script>
import BCardCode from '@core/components/b-card-code/BCardCode.vue'
import {
  BTable, BCol, BCard, BRow, BImg, BBadge, BFormGroup, BFormSelect, BPagination, BInputGroup, BFormInput, BInputGroupAppend, BButton, BCardBody, BLink, BDropdown, BDropdownItem,
} from 'bootstrap-vue'
import ToastificationContent from '@core/components/toastification/ToastificationContent.vue'
import vSelect from 'vue-select'
import moment from 'moment'
import axios from 'axios'
import flatPickr from 'vue-flatpickr-component'
import XLSX from 'xlsx'

export default {
  components: {
    XLSX, moment, flatPickr, BCardCode, vSelect, BTable, BCol, BCard, BRow, BImg, BBadge, BFormGroup, BFormSelect, BPagination, BInputGroup, BFormInput, BInputGroupAppend, BButton, BCardBody, BLink, BDropdown, BDropdownItem, ToastificationContent,
  },
  data() {
    return {
      options: [
        { value: 'd', name: 'Day' },
        { value: 'h', name: 'Hour' },
        { value: 'm', name: 'Month' },
      ],
      date_start: moment(String(new Date())).format('YYYY-MM-DD'),
      date_finish: moment(String(new Date())).format('YYYY-MM-DD'),
      dir: false,
      currentPage: 1,
      sortBy: '',
      sortDesc: false,
      sortDirection: 'asc',
      filter: null,
      filterOn: [],
      key: 0,
      params: {
        date_start: '',
        date_finish: '',
      },
      infoModal: {
        id: 'info-modal',
        title: '',
        content: '',
      },
      status: [{
        AC: 'Active', 2: 'Professional', 3: 'Rejected', 4: 'Resigned', 5: 'Applied',
      },
      {
        AC: 'light-primary', 2: 'light-success', 3: 'light-danger', 4: 'light-warning', 5: 'light-info',
      }],
      fields: [
        { key: 'id', label: 'ID', sortable: true },
        { key: 'date_time', label: 'Date Time', sortable: true },
        { key: 'ph', label: 'pH', sortable: true },
        { key: 'nh3', label: 'NH3', sortable: true },
        { key: 'cod', label: 'COD', sortable: true },
        { key: 'tss', label: 'TSS', sortable: true },
      ],
      items: [

      ],
    }
  },

  mounted() {
    // Fetch data when the component is mounted
    this.fetchData()
  },
  methods: {
    async fetchData() {
       try {
        const response = await axios.get('https://api.universal-iot.com/rest-uiot/v-1/internal/sparing/report/data', {
          params: {
            type_report: this.type_report,
            date_start: moment(this.date_start).format('YYYY-MM-DD'),
            date_finish: moment(this.date_finish).format('YYYY-MM-DD'),
          },
        })
        this.items = response.data.data
      } catch (error) {
        console.error('Error fetching data:', error)
      }
    },

    filterData() {
      const filtertype = this.params.type_report
      const filterStartDate = new Date(this.params.date_start)
      const filterEndDate = new Date(this.params.date_finish)

      this.items = this.items.filter(item => {
        const itemDate = new Date(item.date_time)
        return itemDate >= filterStartDate && itemDate && filtertype <= filterEndDate
      })
    },
  },
}
</script>
<style lang="scss">
@import '@core/scss/vue/libs/vue-select.scss';
</style>
<style lang="scss">
@import '@core/scss/vue/libs/vue-flatpicker.scss';
</style>
